import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FormTip from '../../commons/form_tip';
import {getCsrfToken} from '../../commons/authenticityToken';

const Index = (props) => {
    axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
    // テンプレート初期値
    let mTemplateInit = { name: null, display_web_name: null, description: null, template_kbn: 20, template_code: null};
    let mPartGroupInit = {id: null, name: null, display_web_name: null, common_kbn: 0}
    
    // テンプレート内容
    const [ template, setTemplate ] = useState(mTemplateInit);

    // 新患テンプレート一覧
    const [ newTemplates, setNewTemplates ] = useState([]);
    // カテゴリ検索結果
    const [ resultPartGroups, setResultPartGroups ] = useState([]);
    // 検索
    const [ searchName, setSearchName ] = useState("");
    // 選択中のカテゴリリスト
    const [ checkedPartGroupIds, setCheckedPartGroupIds ] = useState([]);
    // カテゴリリスト
    const [ partGroups, setPartGroups ] = useState([]);
    // 選択中のカテゴリ
    const [ checkedPartGroup, setCheckedPartGroup ] = useState(mPartGroupInit);
    // 再来向け必須カテゴリ
    const [ returnCommonPartGroup, setReturnCommonPartGroup] = useState([]);
    // エラーメッセージ
    const [errorMessage, setErrorMessage] = useState("");
    // レンダリング用
    const [ update, setUpdate ] = useState<Boolean>(false);

    // 初回ロード
    useEffect(() =>{
        setErrorMessage("");
        if (props.is_edit){
            axios.get(
                '/api/internal/templates/edit', {params: {id: props.m_template_id}}
                )
                .then(function (response) {
                    setTemplate(response.data.m_template);
                    setNewTemplates(response.data.new_templates);
                    setPartGroups(response.data.m_part_groups)
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                });
        }else{
            axios.get(
                '/api/internal/templates/new', {})
                .then(function (response) {
                    setTemplate(response.data.m_template);
                    setNewTemplates(response.data.new_templates);
                    setPartGroups(response.data.m_part_groups)
                    setReturnCommonPartGroup(response.data.return_common_part_groups)
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                }
            )
        }
    },[])

    // カテゴリ検索
    function searchPartGroups(){
        initSearchForm();
        axios.get(
        '/api/internal/part_groups/get_part_groups', {
            params: {
            name:  searchName
            }
        })
        .then(function (response) {
            setResultPartGroups(response.data.m_part_groups);
        })
        .catch(error => {
            setResultPartGroups([]);
            alert(error.response.data.message);
        }); 
    }

    // カテゴリ追加
    function addPartGroup(){
        const partGroupDup = partGroups;
        checkedPartGroupIds.map((checkedPartGroupId) => {
            const addPartGroup = resultPartGroups.find(part_group => part_group.id === checkedPartGroupId);
            const part_group = partGroups.find(part_group => part_group.id === checkedPartGroupId);
            // 選択中のカテゴリリストに存在しない場合のみ追加
            if(!part_group){
                partGroupDup.push(addPartGroup);
            }
        })
        setPartGroups(partGroupDup);
        initSearchForm();
        setUpdate(update?false:true);
    }

    // カテゴリ削除
    function removePartGroup(){
        setPartGroups(partGroups.filter(partGroup => partGroup.id !== checkedPartGroup.id));
        setCheckedPartGroup(mPartGroupInit);
    }

    // カテゴリ移動
    function moveRow(type){
        if(checkedPartGroup.id === "") return;

        const partGroupsDup = partGroups.slice();
        const targetIndex = partGroupsDup.findIndex(partGroup => partGroup.id === checkedPartGroup.id)

        switch(type){
            case "up":
                if(targetIndex === 0) return;
                partGroupsDup.splice( targetIndex - 1, 2, partGroupsDup[targetIndex], partGroupsDup[targetIndex - 1]);
                break;
            case "down":
                if(targetIndex === (partGroups.length - 1)) return;
                partGroupsDup.splice( targetIndex, 2, partGroupsDup[targetIndex + 1], partGroupsDup[targetIndex]);
                break;
        }
        setPartGroups(partGroupsDup);
    }

    // 検索フォーム初期化
    function initSearchForm(){
        setResultPartGroups([]);
        setCheckedPartGroupIds([]);
    }

    // チェックボックス選択
    function changeCheckedPartGroupIds(value){
        const checkedPartGroupIdsDup = checkedPartGroupIds
        const isChecked = checkedPartGroupIds.includes(value);
        if(isChecked){
            setCheckedPartGroupIds(checkedPartGroupIdsDup.splice(value));
        }else{
            checkedPartGroupIdsDup.push(value);
            setCheckedPartGroupIds(checkedPartGroupIdsDup);
        }
        setUpdate(update?false:true);
    }

    function submitTemplate(){
        setErrorMessage("");
        if (props.is_edit){
            axios.post(
                '/api/internal/templates/update', {
                    template: template, partGroups: partGroups
                })
                .then(function () {
                    location.href = ("/templates/index");
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                });
        }else{
            axios.post(
                '/api/internal/templates/create', {
                    template: template, partGroups: partGroups
                })
                .then(function () {
                    location.href = ("/templates/index");
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                });
        }

    }

    function changeTemplateKbn(value){
        setTemplate({...template, template_kbn: Number(value)});
        // 必須カテゴリの設定
        if (Number(value) === 20){
            setPartGroups(partGroups.filter(partGroup => partGroup.common_kbn != 2));
        } else{
            setPartGroups(partGroups.concat(returnCommonPartGroup));
        }
    }

    return(
        <>
            { errorMessage && 
                <div className="alert alert-danger alert-dismissible" role="alert">
                    <button 
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="閉じる">
                            <span aria-hidden="true">×</span>
                    </button>
                    { errorMessage }
                </div>
            }
            <div className="row">
                <div className="col-md-2 col-lg-3"/>
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6">
                    <div className="form-group">
                        <FormTip description="アンケートに名前をつけてください">
                            <label htmlFor="m_template_name">アンケート名</label><span className="label label-danger ml5">必須</span>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="例：男性用アンケート2" 
                            type="text" 
                            id="m_template_name"
                            defaultValue={template.name}
                            onChange={(e) => setTemplate({...template, name: e.target.value})}
                        />
                    </div>

                    <div className="form-group">
                        <FormTip description="患者入力画面に表示される際、アンケート名と別名称にしたい場合設定してください">
                            <label htmlFor="m_template_display_name">アンケート名（患者画面）</label>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="例：男性用アンケート" 
                            type="text" 
                            id="m_template_display_name"
                            defaultValue={template.display_web_name}
                            onChange={(e) => setTemplate({...template, display_web_name: e.target.value})}
                        />
                    </div>

                    <div className="form-group">
                        <FormTip description="管理画面に表示される説明文">
                            <label htmlFor="m_template_description">アンケート詳細</label>
                        </FormTip>
                        <textarea 
                            rows={3}
                            className="form-control" 
                            placeholder="アンケート詳細を入力してください"
                            id="m_template_description"
                            defaultValue={template.description}
                            onChange={(e) => setTemplate({...template, description: e.target.value})}
                        />
                    </div>
                    { !props.is_edit && 
                        <div className="form-group">
                            <label>アンケート種類</label><span className="label label-danger ml5">必須</span>
                            <br/>
                            <div className="radio-inline">
                                <input 
                                    className="radio-input" 
                                    type="radio" 
                                    value={20}
                                    id="m_template_kbn_20" 
                                    name="m_template_kbn"
                                    onChange={(e) => changeTemplateKbn(e.target.value)}
                                    defaultChecked={ template.template_kbn === 20 }
                                    disabled={props.is_edit}
                                />
                                <label className="m10" htmlFor="m_template_kbn_20">新患</label>
                                <input 
                                    className="radio-input"
                                    type="radio"
                                    value={30}
                                    id="m_template_kbn_30"
                                    name="m_template_kbn"
                                    onChange={(e) => changeTemplateKbn(e.target.value)}
                                    defaultChecked={ template.template_kbn === 30 }
                                    disabled={props.is_edit}
                                />
                                <label className="m10" htmlFor="m_template_kbn_30">再来</label>
                            </div>
                        </div>
                    }

                    {/* 再来の場合のみ表示 */}
                    {(template.template_kbn === 30) && (
                        <div className="form-group">
                            <FormTip description="再来アンケートに紐づける新患アンケートを選択してください">
                                <label>新患アンケート名</label><span className="label label-danger ml5">必須</span>
                            </FormTip>
                            <select 
                                className="form-control" 
                                id="select_template_code"
                                onChange={(e) => setTemplate({...template, template_code: e.target.value})}
                                disabled={props.is_edit}
                            >
                                <option value="">新患アンケートを選択してください</option>
                                {newTemplates.map((newTemplate) => {
                                    return(
                                        <>
                                            <option value={newTemplate.template_code} selected={newTemplate.template_code === template.template_code}> 
                                                {newTemplate.display_web_name}
                                            </option>
                                        </>
                                    )
                                })}
                            </select>
                        </div>
                    )}

                    {/* カテゴリ設定 */}
                    <div className="form-group">
                        <FormTip description="アンケートに紐づくカテゴリを設定してください">
                            <label htmlFor="m_template_category">カテゴリ設定</label><span className="label label-danger ml5">必須</span>
                        </FormTip>
                        <div className="text-left col-md-6 col-sm-6 col-xs-6 part-group-add">
                            {   (checkedPartGroup.id !== null) &&
                                <>
                                    <a className="btn btn-primary mr10" onClick={()=> moveRow('up')}>▲</a>
                                    <a className="btn btn-primary mr10" onClick={()=> moveRow('down')}>▼</a>
                                </>
                            }
                        </div>
                        <div className="text-right col-md-6 col-sm-6 col-xs-6 part-group-add">
                            <a className="btn btn-primary mr10" data-toggle="modal" data-target="#myModal">追加</a>
                            {   (checkedPartGroup.id !== null) && (checkedPartGroup.common_kbn === 0) &&
                                (<a className="btn btn-danger mr10" onClick={()=> removePartGroup()}>削除</a>)
                            }
                        </div>
                        
                        <table id="notice_table" className="table table-bordered">
                            <thead>
                                <tr className="success">
                                    <th className="col-md-6 col-sm-6 col-xs-6 text-center">カテゴリ名</th>
                                    <th className="col-md-6 col-sm-6 col-xs-6 text-center">説明</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    partGroups.map((partGroup) => {
                                        const isChecked = partGroup.id === checkedPartGroup.id;
                                        return(
                                        <tr className={isChecked ? ("select-part-group") : ("")} onClick={() => setCheckedPartGroup(partGroup)}>
                                            <td>{partGroup.name}</td>
                                            <td>{partGroup.description}</td>
                                        </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>
                    </div>

                    {/* ボタン類 */}
                    <div>
                        <div className="actions mt40">
                            <a className="btn btn-primary pull-left m5" href="/templates/index">戻る</a>
                            <a className="btn btn-primary pull-right m5" onClick={() => submitTemplate()}>
                                {(props.is_edit) ? ("更新する") : ("作成する") }
                            </a>
                        </div>
                    </div>
                </div>   
            </div>


            <div id="myModal" className="modal fade" data-backdrop="static" role="dialog">
                <div className="modal-dialog videocall-modal">
                    <div className="modal-content">
                        <div className="modal-header text-center bg-success">
                            <h4 className="modal-title text-center">カテゴリを選択してください</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label htmlFor="m_part_group_name">カテゴリ名</label>
                                <input className="form-control" placeholder="カテゴリ名" type="text" id="m_part_group_name" onChange={(e) => setSearchName(e.target.value)} />
                            </div>

                            <div className="form-group">
                                <a className="btn btn-primary col-md-12 col-sm-12 col-xs-12" onClick={() => searchPartGroups()}>検索</a>
                            </div>

                            <hr className="col-md-12 col-sm-12 col-xs-12"/>
                            
                            <div className="part-group-table-wrapper">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="success">
                                            <th className="col-md-6 col-sm-6 col-xs-6 text-center">カテゴリ名</th>
                                            <th className="col-md-6 col-sm-6 col-xs-6 text-center">説明</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            resultPartGroups.map((partGroup) => {
                                                const isChecked = checkedPartGroupIds.includes(partGroup.id);
                                                return (
                                                    <tr className={isChecked ? ("select-part-group") : ("")} onClick={() => changeCheckedPartGroupIds(partGroup.id)}>
                                                        <td>{partGroup.name}</td>
                                                        <td>{partGroup.description}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer bg-success">
                            <div className="col-md-3 col-sm-3 col-xs-3">
                                <a className="btn btn-primary col-md-12 col-sm-12 col-xs-12" data-dismiss="modal">閉じる</a>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-6"/>
                            
                            <div className="col-md-3 col-sm-3 col-xs-3">
                                {
                                    (checkedPartGroupIds.length >= 1) ? (
                                        <button
                                            type="button" 
                                            className="btn btn-primary col-md-12 col-sm-12 col-xs-12 active" 
                                            data-dismiss="modal" 
                                            onClick={() => addPartGroup()}>追加
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-primary col-md-12 col-sm-12 col-xs-12 disabled"
                                            onClick={() => addPartGroup()}>追加
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Index;